<template lang="">
  <div>
    <el-dialog :visible.sync="showAcknowledged" @close="$emit('close-modal')"  title="" width="35%">
      <template #title>
        <div class="flex flex-wrap justify-center gap-1 text-center">
          <p class="px-16 title-modal text-center text-lg font-semibold mt-5">
            Recipient acknowledged
          </p>
          <acknowledged-icon class="mt-12 -ml-10" />
        </div>
      </template>
      <div class="px-6 text-left">
        <div class="flex flex-wrap justify-between">
          <div class="w-1/2">
            <p class="modal-title">3PL Terminal</p>
            <p>
              {{
                orgName
              }}
            </p>
          </div>
          <div class="w-1/2 text-left pl-24">
            <p class="modal-title">Name</p>
            <p class="">
              {{
                data.message.origin.sender == null
                  ? "N/A"
                  : data.message.origin.sender.firstname +
                    " " +
                    data.message.origin.sender.lastname
              }}
            </p>
          </div>
        </div>

        <div class="flex flex-wrap justify-between mt-4">
          <div class="w-1/2">
            <p class="modal-title">Phone Number</p>
            <p>
              {{
                data.message.origin.sender == null ? "N/A" : data.message.origin.sender.mobile_no
              }}
            </p>
          </div>
          <div class="text-left pl-24 w-1/2">
            <p class="modal-title">Address</p>
            <p class="">
              {{
                data.message.location == null
                  ? "N/A"
                  : data.message.location.address
              }}
            </p>
          </div>
        </div>

        <div class="flex flex-wrap justify-between mt-4">
          <div class="w-1/2">
            <p class="modal-title">State</p>
            <p>
              {{
                data.message.location == null
                  ? "N/A"
                  : "N/A"
              }}
            </p>
          </div>
          <div class="w-1/2 text-left pl-24">
            <p class="modal-title">Email</p>
            <p class="">
              {{ data.message.origin.sender == null ? "N/A" : data.message.origin.sender.email }}
            </p>
          </div>
        </div>

        <div class="flex flex-wrap justify-between mt-4">
          <div class="w-1/2">
            <p class="modal-title">Delivery Status</p>
            <p class="text-status">{{ data.message.reason }}</p>
          </div>
          <div class="w-1/2 text-left pl-24">
            <p class="modal-title">Receipt code</p>
            <p class="">******</p>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: ["showAcknowledged", "data"],
  computed: {
     orgName(){
      return this.data?.message?.orgReceiver?.companyname || "N/A"
    }
  },
  methods : {
    closeIt(){
      alert("closing")
      this.$emit('close-modal')
      this.$destroy();
    }
  }
};
</script>
<style lang=""></style>
